import { render, staticRenderFns } from "./ViewUser.vue?vue&type=template&id=fb031bc0&scoped=true&"
import script from "./ViewUser.vue?vue&type=script&lang=js&"
export * from "./ViewUser.vue?vue&type=script&lang=js&"
import style0 from "./ViewUser.vue?vue&type=style&index=0&id=fb031bc0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb031bc0",
  null
  
)

export default component.exports